﻿// NG 2 
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';

// APP
import { AuthenticationService } from './authentication.service';
import { SharedService } from './shared.service';
import { AppConfig } from '../app.config';

@Injectable()
export class AccountService extends BaseService  {

    _baseUrl: string = AppConfig.config.defaultServicePath + 'MIHUser/';

    constructor(private http: Http
        , private authenticationService: AuthenticationService
        , private sharedService: SharedService
        , private progressService: ProgressService) {
        super();
    }

    saveAccount(account) {
        this.progressService.add();
        //let headers = new Headers({ 'Content-Type': 'application/json' });
        //headers.append('token', "{sessionId: 12345, user: 'GUEST'}");

        return this.http.post(this._baseUrl + 'UpdateAccount', account, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }
    
    getAccountByUserId(userId) {
        this.progressService.add(); 
        return this.http.get(this._baseUrl + 'GetUserAccount?userId=' + userId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    errorHandler(error: Response) {
        if (error.status == 401)
            this.sharedService.removeData('currentUser');

        if (error.statusText == null || error.statusText == '')
            error.statusText = 'Server Error';

        console.log(error.statusText);
        return Observable.throw(error || { statusText: 'Server Error' });
    }


}